import { useNavigate } from 'react-router-dom';

const articles = [
  {
    title: 'The Complete AllChinaBuy Spreadsheet Guide for Beginners',
    excerpt: 'Learn how to use the allchinabuy spreadsheet to find trusted sellers, compare products, check QC photos, and save money on your purchases. A step-by-step walkthrough for new buyers.',
    category: 'Guide',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20displaying%20data%20notebook%20coffee%20cup%20and%20minimal%20desk%20accessories%20on%20light%20oak%20desk%20warm%20morning%20sunlight%20streaming%20through%20window%20editorial%20productivity%20photography&width=800&height=600&seq=art-guide-v2&orientation=landscape',
    slug: '/allchinabuy-spreadsheet-guide',
  },
  {
    title: '50 Best Shoes in the AllChinaBuy Spreadsheet (2026 Edition)',
    excerpt: 'Discover the top 50 shoe finds from our allchinabuyspreadsheet database. Nike, Jordan, Adidas, and more verified seller links with QC photos included.',
    category: 'Shoes',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20trendy%20sneakers%20in%20various%20colors%20and%20styles%20displayed%20on%20light%20concrete%20floor%20minimal%20editorial%20product%20photography%20with%20natural%20daylight%20soft%20shadows%20fashion%20footwear%20display&width=800&height=600&seq=art-shoes-v2&orientation=landscape',
    slug: '/allchinabuy-best-shoes-spreadsheet-2026',
  },
  {
    title: 'Top AllChinaBuy Trusted Sellers List You Can Rely On',
    excerpt: 'Our curated list of allchinabuy trusted sellers with proven track records. Community-vetted, regularly updated, and organized by product category.',
    category: 'Sellers',
    image: 'https://readdy.ai/api/search-image?query=Professional%20product%20catalog%20with%20various%20clothing%20items%20tags%20and%20labels%20on%20light%20surface%20minimal%20editorial%20photography%20warm%20natural%20lighting%20clean%20organized%20aesthetic&width=800&height=600&seq=art-sellers-v2&orientation=landscape',
    slug: '/allchinabuy-trusted-sellers-list',
  },
  {
    title: 'AllChinaBuy Clothing Spreadsheet – Best Apparel Finds',
    excerpt: 'From hoodies and jackets to t-shirts and pants, discover the best clothing finds in the allchinabuy spreadsheet. Organized by brand, style, and price range.',
    category: 'Clothing',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20streetwear%20clothing%20flat%20lay%20with%20hoodies%20t-shirts%20and%20jackets%20in%20neutral%20earth%20tones%20on%20light%20surface%20minimal%20editorial%20fashion%20photography%20natural%20daylight%20clean%20composition&width=800&height=600&seq=art-clothing-v2&orientation=landscape',
    slug: '/allchinabuy-clothing-spreadsheet-guide',
  },
  {
    title: 'AllChinaBuy QC Photos – Complete Quality Check Guide',
    excerpt: 'Master the art of reviewing QC photos before shipping. Learn what to look for in stitching, logos, materials, colors, and measurements.',
    category: 'Guide',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20product%20details%20on%20light%20desk%20minimal%20editorial%20photography%20warm%20natural%20lighting%20clean%20professional%20aesthetic%20quality%20inspection%20concept%20with%20soft%20shadows&width=800&height=600&seq=art-qc-v2&orientation=landscape',
    slug: '/allchinabuy-qc-photos-guide',
  },
  {
    title: 'AllChinaBuy Yupoo Spreadsheet – Hidden Gem Connections',
    excerpt: 'Discover how the allchinabuy yupoo spreadsheet connects buyers with exclusive seller galleries. Complete guide to navigating Yupoo albums.',
    category: 'Tips',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20product%20gallery%20images%20on%20light%20desk%20with%20coffee%20and%20notebook%20minimal%20editorial%20photography%20warm%20natural%20lighting%20clean%20modern%20tech%20aesthetic&width=800&height=600&seq=art-yupoo-v2&orientation=landscape',
    slug: '/allchinabuy-yupoo-spreadsheet-guide',
  },
  {
    title: 'AllChinaBuy Bags Spreadsheet – Luxury & Casual Picks',
    excerpt: 'Explore the best bags in the allchinabuyspreadsheet. Crossbody bags, backpacks, totes, and luxury-inspired pieces with trusted seller links.',
    category: 'Bags',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20collection%20of%20leather%20bags%20totes%20and%20backpacks%20displayed%20on%20light%20marble%20surface%20minimal%20editorial%20product%20photography%20warm%20natural%20lighting%20luxury%20aesthetic%20soft%20shadows&width=800&height=600&seq=art-bags-v2&orientation=landscape',
    slug: '/allchinabuy-bags-spreadsheet-guide',
  },
  {
    title: 'AllChinaBuy Shipping Tips – Save Money on Every Order',
    excerpt: 'Proven strategies to reduce your shipping costs when buying through agents. Consolidation, rehearsal shipping, packaging removal, and more.',
    category: 'Tips',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20packaging%20supplies%20on%20light%20surface%20minimal%20editorial%20photography%20warm%20natural%20lighting%20clean%20professional%20logistics%20aesthetic%20with%20soft%20shadows&width=800&height=600&seq=art-shipping-v2&orientation=landscape',
    slug: '/allchinabuy-shipping-tips-guide',
  },
  {
    title: 'Free AllChinaBuy Finds – Daily Updated Discoveries',
    excerpt: 'Stay ahead with the latest free allchinabuy finds updated daily. New products, trending items, and community favorites across all 14 categories.',
    category: 'Discoveries',
    image: 'https://readdy.ai/api/search-image?query=Exciting%20unboxing%20style%20flat%20lay%20with%20various%20fashion%20items%20sneakers%20accessories%20and%20clothing%20spread%20on%20light%20surface%20minimal%20editorial%20photography%20warm%20natural%20lighting%20joyful%20aesthetic&width=800&height=600&seq=art-finds-v2&orientation=landscape',
    slug: '/free-allchinabuy-finds-daily',
  },
  {
    title: 'AllChinaBuy Spreadsheet vs Alternatives Comparison',
    excerpt: 'Honest comparison of the allchinabuyspreadsheet versus other spreadsheets. See why our platform offers better updates, more categories, and trusted sellers.',
    category: 'Comparison',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20two%20product%20groups%20on%20light%20surface%20minimal%20editorial%20photography%20warm%20natural%20lighting%20clean%20professional%20aesthetic%20versus%20concept&width=800&height=600&seq=art-compare-v2&orientation=landscape',
    slug: '/allchinabuy-spreadsheet-vs-alternatives',
  },
];

export default function ArticleGrid() {
  const navigate = useNavigate();

  return (
    <section id="guide" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div>
            <p className="text-xs md:text-sm text-foreground-400 font-semibold uppercase tracking-widest mb-3">Latest Finds</p>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium italic">
              Guides & Resources
            </h2>
          </div>
          <p className="text-foreground-500 text-sm md:text-base max-w-md mt-4 md:mt-0 leading-relaxed">
            Explore our comprehensive guides and the latest finds from the allchinabuy spreadsheet community.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <button
              key={article.slug}
              onClick={() => { navigate(article.slug); window.scrollTo(0, 0); }}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 hover:shadow-md transition-all cursor-pointer text-left"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 rounded-md text-xs font-semibold mb-3 whitespace-nowrap">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}